const S3_FOLDER = import.meta.env.VITE_NAZKA_ENV === 'production' ? 'prod' : 'dev';
const S3_PMTILES_URL = `https://buildspace.cdn.nazkamapps.com/${S3_FOLDER}`;

export {
  S3_FOLDER,
  S3_PMTILES_URL,
};